<div class="d-flex flex-column w-100">
    <div class="mx-auto">
        <p-skeleton *ngIf="!customerService.publicCustomer.value.customerKey" styleClass="me-1"></p-skeleton>
        <p-skeleton *ngIf="!customerService.publicCustomer.value.customerKey"></p-skeleton>
        {{app.references.toTitleCase(customerService.publicCustomer.value.firstName)}} {{app.references.toTitleCase(customerService.publicCustomer.value.lastName)}}
    </div>
    <div class="mx-auto">
        <p-skeleton *ngIf="!customerService.publicCustomer.value.customerKey"></p-skeleton>
        <span *ngIf="customerService.publicCustomer.value.email && customerService.publicCustomer.value.email !== 'undefined'">
            {{customerService.publicCustomer.value.email?.toLowerCase()}}
        </span>
        
    </div>
    <div class="mx-auto">
        First visited <p-skeleton *ngIf="!customerService.publicCustomer.value.customerKey"></p-skeleton>{{app.moment(customerService.publicCustomer.value.firstVisitDateTime).format('l LT')}}
    </div>
    <div class="mx-auto">
        Most recent visit <p-skeleton *ngIf="!customerService.publicCustomer.value.customerKey"></p-skeleton>{{app.moment(customerService.publicCustomer.value.lastVisitDateTime).format('l LT')}}
    </div>
    <div class="mx-auto mt-2">
        <div *ngIf="customerService.publicCustomer.value.phonesNumbers?.length > 0">Phone numbers</div>
        <ng-container *ngFor="let item of customerService.publicCustomer.value.phonesNumbers">
            <div class="mt-1">
                <fa-icon [icon]='["far","phone"]' class="me-3"></fa-icon>
                {{app.references.phoneNumberToDisplayFormat(item.phone)}}
                <fa-icon [icon]='["far","times-circle"]' class="ms-5" (click)="onRemovePhone(item.phone)"></fa-icon>
            </div>
        </ng-container>
    </div>
    
</div>